/**
 * Image carousel: arrows wrap, keyboard-navigable. Dots are removed to match static.
 */
export default function carousel() {
    var carousels = document.querySelectorAll('[data-carousel]');

    for (var i = 0; i < carousels.length; i++) {
        (function (car) {
            var slides = Array.prototype.slice.call(car.querySelectorAll('.cslide'));
            if (slides.length < 2) { return; }

            var dots = car.querySelector('.cdots');
            if (dots) { dots.remove(); }
            var stale = car.querySelector('.ccount');
            if (stale) { stale.remove(); }

            var current = 0;

            function show(index) {
                current = (index + slides.length) % slides.length;
                var before = (current - 1 + slides.length) % slides.length;
                var after = (current + 1) % slides.length;

                slides.forEach(function (slide, n) {
                    slide.removeAttribute('data-on');
                    slide.removeAttribute('data-prev');
                    slide.removeAttribute('data-next');
                    if (n === current) { slide.setAttribute('data-on', ''); }
                    else if (n === before) { slide.setAttribute('data-prev', ''); }
                    else if (n === after) { slide.setAttribute('data-next', ''); }
                });
            }

            show(0);

            var prev = car.querySelector('[data-cprev]');
            var next = car.querySelector('[data-cnext]');
            if (prev) {
                prev.addEventListener('click', function () {
                    show(current - 1);
                });
            }
            if (next) {
                next.addEventListener('click', function () {
                    show(current + 1);
                });
            }

            car.addEventListener('keydown', function (event) {
                if (event.key === 'ArrowLeft') { show(current - 1); }
                else if (event.key === 'ArrowRight') { show(current + 1); }
            });
        })(carousels[i]);
    }
}
